import React, { useState } from 'react';

interface PasswordResetModalProps {
  temporaryPassword: string;
  expiresAt: string;
  emailSent: boolean;
  warning: string | null;
  onClose: () => void;
}

export default function PasswordResetModal({
  temporaryPassword,
  expiresAt,
  emailSent,
  warning,
  onClose,
}: PasswordResetModalProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(temporaryPassword);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback
      const el = document.createElement('textarea');
      el.value = temporaryPassword;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const expiresDate = new Date(expiresAt);
  const expiresStr = expiresDate.toLocaleString('ru-RU');

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <div className="bg-slate-800 rounded-xl border border-orange-600/40 p-6 w-full max-w-lg">
        <h2 className="text-lg font-bold text-white mb-4">Сброс пароля</h2>

        {/* Warning if email not sent */}
        {warning && (
          <div className="mb-4 px-4 py-3 bg-orange-600/20 border border-orange-600/40 rounded-lg">
            <p className="text-orange-300 text-sm">{warning}</p>
          </div>
        )}

        {/* Email status */}
        <div className="mb-4">
          <p className="text-sm text-slate-400 mb-1">
            {emailSent ? '✅ Email отправлен' : '⚠️ Email не отправлен (SMTP не настроен)'}
          </p>
        </div>

        {/* Temporary password */}
        <div className="mb-4">
          <label className="block text-sm text-slate-400 mb-1">Временный пароль</label>
          <div className="flex gap-2">
            <div className="flex-1 px-4 py-2.5 bg-slate-900 border border-slate-600 rounded-lg text-white font-mono text-lg tracking-wider">
              {temporaryPassword}
            </div>
            <button
              onClick={handleCopy}
              className="px-4 py-2 text-sm bg-purple-600/20 text-purple-400 rounded-lg hover:bg-purple-600/40 transition whitespace-nowrap"
            >
              {copied ? 'Скопировано!' : 'Копировать'}
            </button>
          </div>
        </div>

        {/* Expiry */}
        <div className="mb-6">
          <p className="text-sm text-slate-400">
            Действителен до: <span className="text-white">{expiresStr}</span>
          </p>
        </div>

        {/* Close */}
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2.5 text-sm bg-slate-700 text-white rounded-lg hover:bg-slate-600 transition"
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
}
